export default "__VITE_ASSET__2227c215__"